import { createFileRoute, notFound } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { blogPostHead, isBlogSlug } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Retired duplicate-intent blog posts — consolidated into their cluster survivor
const RETIRED_POSTS: Record<string, string> = {
  "commercial-electrician-services-louisville-ky": "/blog/commercial-electrician-louisville-ky",
  "commercial-electrical-services-louisville-ky": "/blog/commercial-electrician-louisville-ky",
  "commercial-hvac-maintenance-louisville": "/blog/commercial-hvac-maintenance-louisville-ky",
  "commercial-led-retrofit-upgrade-guide": "/blog/commercial-lighting-retrofit-louisville-ky",
  "commercial-lighting-installation-led-retrofits": "/blog/commercial-lighting-retrofit-louisville-ky",
};

export const Route = createFileRoute("/blog/$slug")({
  beforeLoad: ({ params }) => {
    const target = RETIRED_POSTS[params.slug];
    if (target) legacyRedirect(target);
    if (!isBlogSlug(params.slug)) throw notFound();
  },
  component: BlogPost,
  notFoundComponent: () => <NotFound hubPath="/blog" hubLabel="Blog & Resources" />,
  head: ({ params }) => blogPostHead(params.slug),
});
